import { combineReducers } from "redux";
import { messageReducer } from "@agricircle/shared/redux";
import {farmsReducer } from "@agricircle/shared/farms/redux";
import soil from "./soil";
import sampling from "./sampling";

export const reducer = combineReducers({
    messages: messageReducer,
    farms: farmsReducer,
    soil,
    sampling
});

export const RootState = reducer;
